import { Link } from "gatsby";
import React from "react";

function NewOrangeStrip() {
  const newUrl = "/website-translation/multilingual-seo-services/";
  const url = newUrl.replace(/\/$|$/, "/");

  return (
    <div className="w-full bg-newOrangeStrip bg-cover bg-center text-white pt-[72px] pb-16">
      <div className="max-w-6xl mx-auto mlap:px-6">
        <h2 className="text-45 font-secondary font-semibold leading-[55px] mb-10">
          SEO-Friendly Website Translation
        </h2>
        <p className="text-[18px] font-opensans mb-9 lg:pr-[115px]">
          Website translation and multilingual SEO should be two peas in a pod.
          Search engines like Google account for approximately 30% of global
          website traffic, and we want to make sure your content is ready for
          them. Making sure your translated web content is SEO friendly sets you
          up for global growth, so why not start now.
        </p>
        <p className="text-[20px] font-opensans">
          Broaden your horizons with multilingual SEO services.&nbsp;
          <Link
            // to="/website-translation/multilingual-seo-services/"
            to={url}
            className="font-bold underline hover:text-[#00173A] transition-colors duration-300"
          >
            See how you can get started.
          </Link>
        </p>
      </div>
    </div>
  );
}

export default NewOrangeStrip;
